import React, { useState, useEffect } from "react";
import "./ReviewPage.css";

import { db } from "../../firebase";
import { collection, addDoc, getDocs } from "firebase/firestore";

const ReviewPage = () => {
  const [reviews, setReviews] = useState([]);

  const [form, setForm] = useState({
    name: "",
    rating: 0,
    message: "",
  });

  // 🔥 Fetch reviews from Firebase
  const fetchReviews = async () => {
    const querySnapshot = await getDocs(collection(db, "reviews"));

    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setReviews(data);
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  // 🔥 Submit review to Firebase
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.message || form.rating === 0) {
      alert("Please fill all fields");
      return;
    }

    try {
      await addDoc(collection(db, "reviews"), {
        name: form.name,
        rating: form.rating,
        message: form.message,
        createdAt: new Date(),
      });

      alert("Review submitted ✅");

      setForm({
        name: "",
        rating: 0,
        message: "",
      });

      fetchReviews(); // reload data
    } catch (error) {
      console.error(error);
      alert("Error submitting review ❌");
    }
  };

  return (
    <div className="review-container">
      <h1>Customer Reviews</h1>

      {/* Form */}
      <form className="review-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Your Name"
          value={form.name}
          onChange={(e) =>
            setForm({ ...form, name: e.target.value })
          }
        />

        <textarea
          placeholder="Write your review..."
          value={form.message}
          onChange={(e) =>
            setForm({ ...form, message: e.target.value })
          }
        />

        <div className="star-input">
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={form.rating >= star ? "active" : ""}
              onClick={() =>
                setForm({ ...form, rating: star })
              }
            >
              ★
            </span>
          ))}
        </div>

        <button type="submit">Submit Review</button>
      </form>

      {/* Reviews */}
      <div className="review-grid">
        {reviews.map((review) => (
          <div className="review-card" key={review.id}>
            <h3>{review.name}</h3>

            <div className="stars">
              {"★".repeat(review.rating)}
              {"☆".repeat(5 - review.rating)}
            </div>

            <p>{review.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewPage;